import { useRef, useState, useEffect } from 'react';

interface VideoPlayerProps {
  src: string;
  title?: string;
}

export default function VideoPlayer({ src, title }: VideoPlayerProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(false);
    if (videoRef.current) {
      try {
        videoRef.current.load();
      } catch {
        // ignore
      }
    }
  }, [src]);

  return (
    <div className="grid gap-1.5">
      {!src ? (
        <div className="w-full h-[400px] bg-accent rounded-xl" />
      ) : error ? (
        <div className="grid place-items-center w-full h-[400px] bg-secondary border border-dashed border-border text-muted-foreground rounded-xl">
          Could not find the video
        </div>
      ) : (
        <video
          ref={videoRef}
          className="w-full h-[400px] bg-black rounded-xl outline-none"
          controls
          playsInline
          onError={() => setError(true)}
        >
          <source src={src} />
          Your browser does not support the video tag.
        </video>
      )}
      {title && <div className="text-muted-foreground text-xs">{title}</div>}
    </div>
  );
}
